import { render } from "./MyPageEmailSettings.vue?vue&type=template&id=2d76d620&scoped=true&ts=true"
import script from "./MyPageEmailSettings.vue?vue&type=script&lang=ts"
export * from "./MyPageEmailSettings.vue?vue&type=script&lang=ts"

import "./MyPageEmailSettings.vue?vue&type=style&index=0&id=2d76d620&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d76d620"]])

export default __exports__